import React from "react";
import "./ConfirmationModal.scss"
import {ImageConfig} from "../../../constants";
import ButtonComponent from "../button/ButtonComponent";

interface ConfirmationModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    confirmText?: string;
    confirmationMessage?: any
    closeButtonRequired?: boolean
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
                                                                 isOpen,
                                                                 onClose,
                                                                 onConfirm,
                                                                 confirmationMessage,
                                                                 confirmText = "Confirm",
                                                                 closeButtonRequired = true
                                                             }) => {
    if (!isOpen) return null;

    return (
        <div className="confirmation-modal">
            <div className="confirmation-modal__overlay" onClick={onClose}></div>
            <div className="confirmation-modal__content">
                <div className="confirmation-modal__icon">
                    <div className={'d-flex justify-content-center align-items-center'}>
                        <img width={107} height={93} src={ImageConfig.TimeUpIcon}
                             alt={'payment_success_icon'}/>
                    </div>
                </div>
                <h2 className="confirmation-modal__title">Please Confirm!</h2>
                <p className="confirmation-modal__message mrg-top-20">
                    {confirmationMessage}
                </p>
                <div className="confirmation-modal__actions mrg-top-30">
                    {closeButtonRequired &&
                        <ButtonComponent variant={'outlined'} className="confirmation-modal__button cancel"
                                         onClick={onClose}>
                            Cancel
                        </ButtonComponent>}
                    <ButtonComponent className="confirmation-modal__button confirm" onClick={onConfirm}>
                        {confirmText}
                    </ButtonComponent>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;
